export default __webpack_public_path__ + "static/media/photo_5282747746622312918_y.8067f3c5.jpg";